import {Form} from '../../../../../stores/Form';
import {useCallback} from 'react';
import {updateCustomColumnWidth} from '../../../actions/form';

export const useCellResizer = (form: Form) => {
    return useCallback(
        async (newWidth: number, columnId: number) => {
            if (!form || !form?.tableAPI) return;
            const {tableAPI} = form;

            const activeColumn = form.getColumnByID(columnId);

            activeColumn.setWidth(newWidth);
            activeColumn.setMaxWidthMode(false);

            tableAPI.recalcColumnStyles();

            await updateCustomColumnWidth(form, columnId, newWidth);
        },
        [form]
    );
};
